import { useSyncExternalStore } from 'use-sync-external-store/shim';

import workspaceService from '@app/libs/workspaceService';

export function useWorkspaceId() {
  return useSyncExternalStore(
    workspaceService.subscribe.bind(workspaceService),
    () => {
      if (workspaceService.hasWorkspaceId()) {
        return workspaceService.getWorkspaceId();
      }

      return '';
    },
    () => ''
  );
}
